import {useMutation} from "@tanstack/react-query";

import {addRepresentativeNoteMutationOptions} from "./add-representative-note.mutation-options";

export function useAddRepresentativeNote(representativeId: string) {
  return useMutation(addRepresentativeNoteMutationOptions(representativeId));
}
